import apiClient from "./axios"

// ✅ Get all customers (with optional filters or pagination)
export const getCustomers = async (params = {}) => {
  const { data } = await apiClient.get("/customers", { params })
  return data
}

// ✅ Get a single customer by ID
export const getCustomer = async id => {
  const { data } = await apiClient.get(`/customers/${id}`)
  return data
}

// ✅ Create a new customer
export const createCustomer = async Data => {
  const { data } = await apiClient.post("/customers", Data)
  return data
}

// ✅ Update an existing customer
export const editCustomer = async ({ id, ...Data }) => {
  const { data } = await apiClient.patch(`/customers/${id}`, Data)
  return data
}

// ✅ Soft delete (move to trash)
export const deleteCustomer = async id => {
  const { data } = await apiClient.delete(`/customers/${id}`)
  return data
}

// ✅ Permanently delete a trashed customer
export const forceDeleteCustomer = async id => {
  const { data } = await apiClient.delete(`/customers/${id}/force-delete`)
  return data
}

// ✅ Get all customers without pagination
export const getAllCustomers = async (params = {}) => {
  const { data } = await apiClient.get("/customers", {
    params: { ...params, all: true },
  })
  return data
}

// ✅ Search customers by name, slug, or other fields
export const searchCustomers = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/customers", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// ✅ Get trashed (soft-deleted) customers
export const getTrashedCustomers = async (params = {}) => {
  const { data } = await apiClient.get("/customers/trashed", { params })
  return data
}

// ✅ Get a customer by slug
export const getCustomerBySlug = async slug => {
  const { data } = await apiClient.get(`/customers/slug/${slug}`)
  return data
}

// ✅ Restore a trashed customer
export const restoreCustomer = async id => {
  const { data } = await apiClient.post(`/customers/${id}/restore`)
  return data
}
